import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { PageHeader } from '@/components/ui/PageHeader'
import { ProjectsBreadcrumbs } from '../ProjectsBreadcrumbs'
import { ProjectDatabricksIntegrationPageContent } from './ProjectDatabricksIntegrationPageContent'

export function ProjectDatabricksIntegrationPage() {
  return (
    <>
      <PageHeader className="shrink-0 pr-3" title={<ProjectsBreadcrumbs title="Databricks" />} />
      <QueryErrorBoundary errorMessage="Failed to fetch project Databricks integration">
        <ProjectDatabricksIntegrationPageContent />
      </QueryErrorBoundary>
    </>
  )
}
